module.exports = __webpack_public_path__ + "static/img/a5.d8e3cd76.png";